module.exports = __webpack_public_path__ + "static/media/unknown-file.d3ce6c0e.svg";